import {
  PortalAuthCtaSection,
  PortalAuthGate,
} from "@xinosolutions/xs-auth-react/portal";
import { Link as RouterLink } from "react-router-dom";
import SignInLink from "./SignInLink";
import CreateAccountLink from "./CreateAccountLink";
import SiteFooter from "./SiteFooter";

const portalSignInComponents = {
  SignInPrimary: CreateAccountLink,
  SignInSecondary: SignInLink,
};

function renderDashboardLink({ href, className, children }) {
  return (
    <RouterLink to={href} className={className}>
      {children}
    </RouterLink>
  );
}

export default function LandingContent() {
  return (
    <>
      <section className="portal-hero">
        <div className="portal-hero-badge">Xino Solutions</div>
        <h1>
          Learnix
          <br />
          <span className="portal-hero-gradient">Admin console</span>
        </h1>
        <p>
          Sign in with XS Auth to manage schools, teachers, students, and
          content across Learnix. Only Learnix admins can open this console.
        </p>
        <PortalAuthGate
          dashboardHref="/dashboard"
          dashboardLabel="Open dashboard"
          primaryLabel="Create account"
          secondaryLabel="Sign in"
          secondaryClassName="portal-btn portal-btn--ghost"
          renderDashboardLink={renderDashboardLink}
          {...portalSignInComponents}
        />
      </section>

      <PortalAuthCtaSection
        title="Ready to manage Learnix?"
        authenticatedText="You're signed in. Open the dashboard — only Learnix admins can continue."
        unauthenticatedText="Create a free account and open the admin dashboard in seconds."
        dashboardHref="/dashboard"
        dashboardLabel="Open dashboard"
        primaryLabel="Get started"
        showSecondarySignIn={false}
        SignInPrimary={CreateAccountLink}
        renderDashboardLink={renderDashboardLink}
      />

      <SiteFooter />
    </>
  );
}
